/**
 * @fileoverview Data Phase — index route (all-agents summary view)
 *
 * URL: /dashboard/jobs/:jobId/summaries
 *
 * Renders the SummarizationView with the Data agent cards grouped by
 * section. Pre-appointment jobs only show the Corporate agent. Clicking a
 * card navigates to the per-agent slug route (/summaries/$agent) handled
 * by the sibling `$agent` route file.
 */

import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "@cvx/_generated/api";
import type { Id } from "@cvx/_generated/dataModel";
import { SummarizationView } from "@/components/jobs/phases/gather/summarization/SummarizationView";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/jobs/$jobId/summaries/",
)({
  component: SummariesIndex,
});

function SummariesIndex() {
  const { jobId } = Route.useParams();

  const { data: job } = useQuery(
    convexQuery(api.jobs.queries.getJob, { jobId: jobId as Id<"jobs"> }),
  );

  const isViewer = job?.userRole === "viewer";

  // SummarizationView renders with `-m-6` to bleed its `bg-muted` to the
  // edges of a `p-6` parent. We replicate that shell here so the page
  // padding matches the Documents (Gather) page.
  return (
    <div className="flex min-h-full flex-1 flex-col">
      <div className="flex min-h-full flex-1 flex-col p-6">
        <SummarizationView
          jobId={jobId as Id<"jobs">}
          isViewer={isViewer}
          jobStatus={job?.status}
          appointmentType={job?.appointmentType}
        />
      </div>
    </div>
  );
}
